import React, { useEffect, useState, useCallback } from 'react';

import { useZoneCategories } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';
import { BasicSelector, BasicSelectorProps } from './basic-selector';

type ZoneCategorySelectorProps = BasicSelectorProps & {
  value: number | null;
  onChange?: (value: number | null) => void;
};

export const ZoneCategorySelector = ({ onChange: _onChange = () => {}, value, ...rest }: ZoneCategorySelectorProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const { data: zoneCategories, isLoading: loading_zoneCategories } = useZoneCategories();
  const label = 'Zone category';
  const optionsLoadingText = 'Loading zone categories';

  const [options, setOptions] = useState<number[]>([]);
  const getOptionLabel = useCallback(
    (option: number) => zoneCategories.find(({ id }) => id === option)?.title || '',
    [zoneCategories],
  );
  const onChange: any = (_: any, value: number) => _onChange(value);

  useEffect(() => {
    if (!loading_zoneCategories) {
      const o = zoneCategories.map(({ id }) => id);
      setOptions((prevOptions) => {
        if (JSON.stringify(prevOptions) !== JSON.stringify(o)) {
          return o;
        }
        return prevOptions;
      });
    }
  }, [zoneCategories, loading_zoneCategories]);

  const componentProps: Partial<ZoneCategorySelectorProps> = {
    label,
    optionsLoadingText,
    value,
    options,
    getOptionLabel,
    onChange,
    loading: loading_zoneCategories,
    optionsConfig: {
      link: `/${orgSlug}/profile/zone-categories`,
    },
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
